import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import List from "../components/List";
import styles from "../assets/css/SupportMessage.module.css";
import { BASE_URL } from "../constants/constants";

const SupportMessage = () => {
  const [message, setMessage] = useState({});
  const [answerText, setAnswerText] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  const headers = {
    Authorization:
      `Bearer ${token}`,
  };

  const getMessages = (id) => {
    axios
      .get(`${BASE_URL}/v0/support/messages/${id}`, { headers })
      .then((response) => {
        console.log("Message data:", response.data.result);
        setMessage(response.data.result);
      })
      .catch((error) => {
        console.error(
          "There was an error fetching the support messages!",
          error
        );
      });
  };

  const handleSave = () => {
    if (!answerText.trim()) {
      alert("Пожалуйста, введите текст ответа.");
      return;
    }

    const body = {
      answerText: answerText,
      messageID: parseInt(id, 10),
    };

    axios
      .post(`${BASE_URL}/v0/support/messages/${id}`, body, { headers })
      .then((response) => {
        console.log("Response saved:", response.data.result);
        alert("Ответ успешно отправлен!");
      })
      .catch((error) => {
        console.error("Error posting the answer:", error);
        alert("Произошла ошибка при отправке ответа.");
      });
  };

  useEffect(() => {
    if (id) {
      getMessages(id);
    }
  }, [id]);

  return (
    <div>
      <Header />
      <div className={styles.container}>
        <List />
        <div className={styles.container1}>
          <div className={styles.box}>
            <div onClick={() => navigate("/support")} className={styles.text}>
              Поддержка
            </div>
            <img
              className={styles.nexticon}
              src="/images/next.svg"
              alt="next icon"
            />
            <div className={styles.text1}>Подробнее</div>
          </div>
          <div className={styles.container2}>
            <div className={styles.box5}>
              <div className={styles.text3}>Данные пользователя</div>
              <div className={styles.box6}>
                <div className={styles.type}>Email:</div>
                <div className={styles.type1}>{message.email}</div>
              </div>
              <div className={styles.box6}>
                <div className={styles.type}>Номер телефона:</div>
                <div className={styles.type1}>{message.phoneNumber}</div>
              </div>
              <div className={styles.box6}>
                <div className={styles.type}>Дата отправления сообщения:</div>
                <div className={styles.type1}>{message.createdAt}</div>
              </div>
              <div className={styles.text4}>Вопрос</div>
              <div className={styles.question}>{message.text}</div>
              <div className={styles.text4}>Ответ</div>
              <textarea
                rows="8"
                cols="50"
                placeholder="Введите ваш ответ здесь..."
                className={styles.answer}
                value={answerText}
                onChange={(e) => setAnswerText(e.target.value)}
              ></textarea>
            </div>
            <div className={styles.box2}>
              <button
                onClick={() => navigate("/support")}
                className={styles.backbtn}
              >
                Назад
              </button>
              <button onClick={handleSave} className={styles.savebtn}>
                Сохранить
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportMessage;
